const BATCH_DOWNLOAD = 'BatchDownload';
const BATCH_UPLOAD = 'BatchUpload';
const PROVIDER_REFERENCE_DATA = 'ProviderReferenceData';
const FRONT_END_ASSETS = 'FrontEndAssets';


export {
    BATCH_DOWNLOAD,
    BATCH_UPLOAD,
    PROVIDER_REFERENCE_DATA,
    FRONT_END_ASSETS
}